/* Sacola de presente no carrinho (Caio, 29/10/2026). Preenche foto, preco e id da sacola e faz o clique.
   O snippet snippets/mt-sacola.liquid so desenha o botao escondido (sem all_products, que quebrava o Remover). */
(function () {
  if (window.__mtSacola2) return; window.__mtSacola2 = true;
  var cache = {};
  function produto(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[h];
  }
  function reais(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
  function preenche() {
    document.querySelectorAll('[data-mt-sacola-h]:not([data-mt-ok])').forEach(function (b) {
      b.setAttribute('data-mt-ok', '1');
      produto(b.getAttribute('data-mt-sacola-h')).then(function (p) {
        if (!p || !p.available) return;
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        b.setAttribute('data-mt-sacola', v.id);
        var img = b.querySelector('.mt-sacola__img'), u = p.featured_image || '';
        if (img && u) { if (u.indexOf('//') === 0) u = 'https:' + u; img.src = u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=120'; }
        var pr = b.querySelector('.mt-sacola__preco'); if (pr) pr.textContent = reais(v.price);
        b.hidden = false;
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mt-sacola]');
    if (!b) return;
    e.preventDefault();
    var tx = b.querySelector('.mt-sacola__txt') || b; var t0 = tx.textContent; b.disabled = true; tx.textContent = 'Adicionando...';
    try { if (window.clarity) clarity('event', 'sacola_carrinho'); } catch (err) {}
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-mt-sacola')), quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { b.disabled = false; tx.textContent = t0; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preenche); else preenche();
  new MutationObserver(preenche).observe(document.documentElement, { childList: true, subtree: true });
})();
